"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _utils = require("../../utils/utils");
var _constants = require("../../constants/constants");
var _katalFunnelEvents = require("../../events/katal-funnel-events");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BwaQuickCheckoutRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwaQuickCheckoutRenderHandler() {
    var _this;
    (0, _classCallCheck2["default"])(this, BwaQuickCheckoutRenderHandler);
    _this = _callSuper(this, BwaQuickCheckoutRenderHandler);
    _this.bwaOrigin = new URL(_constants.BWA_ENDPOINT).origin;
    _this.tInjected = null;
    _this.perceivedLogged = false;
    return _this;
  }
  (0, _inherits2["default"])(BwaQuickCheckoutRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwaQuickCheckoutRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setupMessageListeners();
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "setupMessageListeners",
    value: function setupMessageListeners() {
      var _this2 = this;
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_TRIGGER, function (event) {
        var detail = event.detail || {};
        var url = _this2.buildQuickCheckoutWidgetUrl(detail);
        _this2.injectQuickCheckoutWidget(url);
      });
      window.addEventListener(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_DISMISS, function () {
        _this2.removeQuickCheckoutWidget();
      });
      window.addEventListener(_constants.EVENT_TYPE.MESSAGE, function (event) {
        var _event$data;
        if (event.origin !== _this2.bwaOrigin) return;
        switch ((_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.type) {
          case _constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_RENDERED:
            {
              var sheet = document.querySelector('.bwa-qc-ecp-sheet');
              if (sheet) sheet.remove();
              var iframe = document.getElementById(_constants.IFRAME_IDS.QUICK_CHECKOUT);
              if (iframe) {
                if (event.data.height != null) {
                  iframe.style.height = event.data.height + 'px';
                }
                iframe.style.opacity = '1';
                iframe.style.position = '';
              }
              if (!_this2.perceivedLogged) {
                _this2.perceivedLogged = true;
                (0, _katalFunnelEvents.logPerceived)("quick_checkout", {
                  tInjected: _this2.tInjected,
                  signalType: "content_visible"
                });
              }
              break;
            }
          case _constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_COMPLETE:
            if (event.data.returnUrl) {
              window.location.href = event.data.returnUrl;
            }
            window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_DISMISS));
            break;
          case _constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_DISMISS:
            window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_DISMISS));
            break;
        }
      });
    }
  }, {
    key: "buildQuickCheckoutWidgetUrl",
    value: function buildQuickCheckoutWidgetUrl(detail) {
      var params = {
        ecp: _constants.ECP,
        ecpShopId: window.storeId,
        items: detail.items || '',
        ecpCustomerId: detail.ecpCustomerId || _constants.SHOPIFY_PLACEHOLDER_CUSTOMER_ID,
        ecpSessionId: detail.ecpSessionId || '',
        checkoutId: detail.ecpCheckoutId || '',
        gaClientId: detail.gaClientId || '',
        gaSessionId: detail.gaSessionId || '',
        returnUrl: detail.returnUrl || '',
        isRequestedForCoupon: detail.isRequestedForCoupon ? 'true' : ''
      };
      var qs = Object.keys(params).filter(function (k) {
        return params[k] !== '';
      }).map(function (k) {
        return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(params[k]));
      }).join('&');
      return "".concat(_constants.BWA_ENDPOINT).concat(_constants.WIDGET_QUICK_CHECKOUT_PATH, "?").concat(qs);
    }
  }, {
    key: "injectQuickCheckoutWidget",
    value: function injectQuickCheckoutWidget(url) {
      var _this3 = this;
      var existingContainer = (0, _utils.safeGetElementById)(_constants.BWA_WIDGET_CONTAINER_IDS.BWA_QUICK_CHECKOUT_CONTAINER_ID);
      if (existingContainer) existingContainer.remove();
      var container = document.createElement('div');
      container.id = _constants.BWA_WIDGET_CONTAINER_IDS.BWA_QUICK_CHECKOUT_CONTAINER_ID;
      container.className = _constants.CSS_CLASSES.QUICK_CHECKOUT_CONTAINER;
      var sheet = document.createElement('div');
      sheet.className = 'bwa-qc-ecp-sheet';
      var spinner = document.createElement('div');
      spinner.className = 'bwa-qc-ecp-spinner';
      sheet.appendChild(spinner);
      container.appendChild(sheet);
      var iframe = (0, _utils.generateIframe)(_constants.IFRAME_IDS.QUICK_CHECKOUT, _constants.CSS_CLASSES.QUICK_CHECKOUT, url);
      this.tInjected = performance.now();
      this.perceivedLogged = false;
      iframe.style.opacity = '0';
      iframe.style.position = 'absolute';
      iframe.style.height = '52vh';
      container.appendChild(iframe);
      document.body.appendChild(container);
      document.body.classList.add('bwa-no-scroll');
      container.addEventListener('click', function (event) {
        if (event.target === container) {
          _this3.removeQuickCheckoutWidget();
          window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.BWA_QUICK_CHECKOUT_DISMISS));
        }
      });
    }
  }, {
    key: "removeQuickCheckoutWidget",
    value: function removeQuickCheckoutWidget() {
      var container = (0, _utils.safeGetElementById)(_constants.BWA_WIDGET_CONTAINER_IDS.BWA_QUICK_CHECKOUT_CONTAINER_ID);
      if (container) container.remove();
      document.body.classList.remove('bwa-no-scroll');
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-quick-checkout-render-handler.js.map
